import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";
import { prettyFormattedDateTimeFromISO } from "../../Helpers/datetimeHelper";
import SessionTypeFormatter from "../../Components/Reusable/List/SessionTypeFormatter";

function OrgUserSessionTemplateListDesktop(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onSelectSessionForDeletion,
  } = props;
  return (
    <div class="b-table">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>No</th>
              <th>Session Type</th>
              <th>Completed</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {listData &&
              listData.map(function (datum, i) {
                return (
                  <tr>
                    <td data-label="ID">{datum.id}</td>
                    <td data-label="Name">{datum.name}</td>
                    <td data-label="No">{datum.no}</td>
                    <td data-label="Session Type">
                      <SessionTypeFormatter sessionType={datum.sessionType} />
                    </td>
                    <td data-label="Completed">
                      {datum.completedTime
                        ? prettyFormattedDateTimeFromISO(datum.completedTime)
                        : "N/a"}
                    </td>
                    <td class="is-actions-cell">
                      <div class="buttons is-right">
                        <Link
                          to={`/user/${datum.userId}/session/${datum.id}`}
                          class="button is-small is-primary"
                          type="button"
                        >
                          <FontAwesomeIcon className="mdi" icon={faEye} />
                          &nbsp;View
                        </Link>
                        {/*
                                        <Link to={`/user/${datum.userId}/session/${datum.id}/edit`} class="button is-small is-warning" type="button">
                                            <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit
                                        </Link>
                                        <button onClick={(e, ses) => onSelectSessionForDeletion(e, datum)} class="button is-small is-danger" type="button">
                                            <FontAwesomeIcon className="mdi" icon={faTrashCan} />&nbsp;Delete
                                        </button>
                                        */}
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <div class="columns">
          <div class="column is-half">
            <span class="select">
              <select
                class={`input has-text-grey-light`}
                name="pageSize"
                onChange={(e) => setPageSize(parseInt(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map(function (option, i) {
                  return (
                    <option
                      selected={pageSize === option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div class="column is-half has-text-right">
            {previousCursors.length > 0 && (
              <button class="button" onClick={onPreviousClicked}>
                Previous
              </button>
            )}
            {listData.hasNextPage && (
              <>
                <button class="button" onClick={onNextClicked}>
                  Next
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrgUserSessionTemplateListDesktop;
